import { db, auth } from "./index";
import bcrypt from "bcryptjs";

export const add = async (collection, data) => {
  return await db.collection(collection).add({
    createdAt: Date.now(),
    isDeleted: false,
    ...data,
  });
};

export const update = async (collection, id, data) => {
  return await db
    .collection(collection)
    .doc(id)
    .update({
      ...data,
    });
};

export const getById = async (collection, id) => {
  let doc = await db.collection(collection).doc(id).get();
  if (!doc.exists) {
    throw new Error(`Not found!!`);
  } else {
    return { id, ...doc.data() };
  }
};

export const fetch = async (collection) => {
  let docs = [];
  let docsSnapshot = await db.collection(collection).get();
  docsSnapshot.forEach((doc) => docs.push({ id: doc.id, ...doc.data() }));
  return docs;
};

export const populateData = async (collection, arrayOfIds) => {
  let allPromises = arrayOfIds.map((id) => getById(collection, id));
  return await Promise.all(allPromises);
};

export const batchUpdate = async (collection, fieldName, value) => {
  let batch = db.batch(),
    docRef,
    docData;
  let docsSnapshot = await db
    .collection(collection)
    .where(fieldName, "array-contains", value)
    .get();
  docsSnapshot.forEach((doc) => {
    docRef = db.collection(collection).doc(doc.id);
    docData = doc.data();
    batch.update(docRef, {
      [`${fieldName}`]: docData[`${fieldName}`].filter(
        (_value) => _value !== value
      ),
    });
  });
  return await batch.commit();
};

export const updateProfile = async (params) => {
  const user = auth.currentUser;
  return await update("users", user.uid, params);
};

export const fetchSubCategoryFields = async (id) => {
  let docs = [];
  let docsSnapshot = await db
    .collection("subCategoryFields")
    .where("subCategoryId", "==", id)
    .get();

  docsSnapshot.forEach((doc) => docs.push({ id: doc.id, ...doc.data() }));
  return docs;
};

export const updatePassword = async (newPassword) => {
  const user = auth.currentUser;
  let password = await bcrypt.hash(newPassword, 10);
  await user.updatePassword(newPassword);
  return await update("users", user.uid, { password: password });
};

export const convertCollectionsSnapshotToMap = (collections) => {
  const transformedCollection = collections.docs.map((doc) => {
    const { title, items } = doc.data();

    return {
      routeName: encodeURI(title.toLowerCase()),
      id: doc.id,
      title,
      items,
    };
  });

  return transformedCollection.reduce((accumulator, collection) => {
    accumulator[collection.title.toLowerCase()] = collection;
    return accumulator;
  }, {});
};

/**method to fetch products in which users has made an offer */
export const fetchBids = async (userId) => {
  let docs = [];
  let docsSnapshot = await db
    .collection("products")
    .where("offerUsers", "array-contains", userId)
    .get();
  docsSnapshot.forEach((doc) => docs.push({ id: doc.id, ...doc.data() }));
  return docs;
};

// method to fetch product
export const getProducts = async (filters) => {
  let query = db.collection("products");
  if (filters.category){
    query = query.where("category", "==", parseInt(filters.category));
    return await query.get();
  }
  else{
    console.log("else condition working");
    return await query.get();
  }
      
};

// method to fetch product details
export const getProductInformation = async () => {
  return await db.collection("products").where("title", "==", 'Angus Bulls').get();
};